export default "__VITE_ASSET__8e1be4a4__"